import { useEffect, useState } from "react";
import { api } from "../lib/api";

const CATEGORY_ORDER = [
  "Preamp",
  "Outboard",
  "Converter",
  "DAW",
  "Monitor",
  "Stüdyo",
  "Mikrofon",
  // --- Enstrümanlar en altta ---
  "Akustik Gitar",
  "Elektro Gitar",
  "Bas Gitar",
  "Klasik Gitar",
  "Akustik Piyano",
  "Davul Seti",
  "Snare",
];

export default function Gear() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/gear").then((r) => setItems(r.data)).finally(() => setLoading(false));
  }, []);

  const byCat = items.reduce((acc, i) => {
    (acc[i.category] = acc[i.category] || []).push(i);
    return acc;
  }, {});

  const sortedCategories = Object.keys(byCat).sort((a, b) => {
    const ia = CATEGORY_ORDER.indexOf(a);
    const ib = CATEGORY_ORDER.indexOf(b);
    if (ia === -1 && ib === -1) return a.localeCompare(b);
    if (ia === -1) return 1;
    if (ib === -1) return -1;
    return ia - ib;
  });

  return (
    <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12 py-16" data-testid="gear-page">
      <div className="mono-caps mb-3">Stüdyo Ekipmanları</div>
      <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight text-white max-w-3xl">
        Analog kalp, <span className="gradient-text">dijital hız</span>.
      </h1>
      <p className="mt-4 text-slate-400 max-w-2xl">Mixlerinizde duyduğunuz karakter buradan geliyor.</p>

      {loading && <div className="text-slate-500 mt-10">Yükleniyor…</div>}

      <div className="mt-12 space-y-12">
        {sortedCategories.map((cat) => (
          <section key={cat}>
            <div className="mono-caps text-amber-400">{cat}</div>
            <div className="grid md:grid-cols-3 gap-4 mt-4">
              {byCat[cat].map((g) => (
                <div key={g.gear_id} className="panel p-5 panel-hover" data-testid={`gear-item-${g.gear_id}`}>
                  <div className="font-display text-lg text-white">{g.name}</div>
                  {g.brand && g.brand !== "-" && <div className="text-sm text-cyan-300 mt-1">{g.brand}</div>}
                  {g.description && <p className="text-sm text-slate-400 mt-3">{g.description}</p>}
                </div>
              ))}
            </div>
          </section>
        ))}
      </div>
    </main>
  );
}
